import React, {FC} from 'react'
import {Link} from 'react-router-dom'
import {KTSVG} from '../../../helpers'
import {ActivityDrawerItem} from '../../../../app/components/ActivityDrawerItem'
import {useSelector} from 'react-redux'
import {RootState} from '../../../../setup'

const ActivityDrawer: FC = () => {
  const account: any = useSelector<RootState>(({account}) => account.appAccount)
  const {data: activities, isLoading: activitiesLoading}: any = useSelector<RootState>(
    ({app}) => app.activities
  )
  return (
    <div
      id='kt_activities'
      className='bg-white'
      data-kt-drawer='true'
      data-kt-drawer-name='activities'
      data-kt-drawer-activate='true'
      data-kt-drawer-overlay='true'
      data-kt-drawer-width="{default:'200px', 'lg': '900px'}"
      data-kt-drawer-direction='end'
      data-kt-drawer-toggle='#kt_activities_toggle'
      data-kt-drawer-close='#kt_activities_close'
    >
      <div className='card shadow-none rounded-0 w-100'>
        <div className='card-header' id='kt_activities_header'>
          <h3 className='card-title fw-bolder text-dark'>Son Aktiviteler</h3>
          <div className='card-toolbar'>
            <button
              type='button'
              className='btn btn-sm btn-icon btn-active-light-primary me-n5'
              id='kt_activities_close'
            >
              <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-1' />
            </button>
          </div>
        </div>
        <div className='card-body position-relative' id='kt_activities_body'>
          <div
            id='kt_activities_scroll'
            className='position-relative scroll-y me-n5 pe-5'
            data-kt-scroll='true'
            data-kt-scroll-height='auto'
            data-kt-scroll-wrappers='#kt_activities_body'
            data-kt-scroll-dependencies='#kt_activities_header, #kt_activities_footer'
            data-kt-scroll-offset='0'
          >
            {activitiesLoading ? (
              <div>Yükleniyor...</div>
            ) : !activities || activities.length === 0 ? (
              <div>Henüz bir aktivite kaydı yok</div>
            ) : (
              <div className='timeline'>
                {activities.map((activity: any, index: any) => (
                  <ActivityDrawerItem
                    {...activity}
                    user={account.companyUser?.first_Name}
                    key={index}
                  />
                ))}
              </div>
            )}
          </div>
        </div>

        <div className='card-footer py-5 text-center' id='kt_activities_footer'>
          <Link to='/' className='btn btn-bg-white text-primary'>
            Tüm Aktiviteleri Göster
            <KTSVG
              path='/media/icons/duotune/arrows/arr064.svg'
              className='svg-icon-3 svg-icon-primary'
            />
          </Link>
        </div>
      </div>
    </div>
  )
}

export {ActivityDrawer}
